module.exports = __webpack_public_path__ + "bd02f0a22ba79be90b1df7c64b9bc9e0.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-group/accounts/delete/delete-accounts.html
// module id = 1779
// module chunks = 0